import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { WindowRefService } from '../../../shared/services/window-ref.service';
import { Observable, Subscription } from 'rxjs/Rx';

@Component({
  selector: 'tr-base-file-type',
  template: '<div>I am based file type component</div>'
})
export class BaseFileTypeComponent<T> implements OnInit, OnDestroy {
  @Input() componentDef: T;
  @Input() contentIsViewed$: Observable<boolean>;
  @Input() contentIsDownloading$: Observable<boolean>;
  @Input() contentData$: Observable<any>;
  @Input() contentIsConfirmed$: Observable<boolean>;
  @Input() currentAction$: Observable<string>;
  @Input() token: string;
  @Output() componentAction = new EventEmitter<any>();

  private nativeWindow: any;
  protected content: any;
  protected subscriptions: Array<Subscription> = [];

  constructor(windowRef: WindowRefService) {
    this.nativeWindow = windowRef.getNativeWindow();
  }

  ngOnInit() {
    this.subscriptions.push(
      this.contentData$.subscribe(content => this.content = content)
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  protected isIOS(): boolean {
    return this.nativeWindow.Modernizr.appleios;
  }

  protected getButtonText(isFileDownloaded: boolean, downloadedText: string, undownloadedText: string): string {
    return (isFileDownloaded && this.content !== '') ? downloadedText : undownloadedText;
  }

  protected onAction(actionName: string): void {
    if (actionName.toLowerCase() !== 'add to calendar' && actionName.toLowerCase() !== 'view') {
      this.componentAction.emit(actionName);
    } else {
      if (!this.isIOS() || (this.isIOS() && this.content === '')) {
        this.componentAction.emit(actionName);
      } else {
        if (this.content instanceof Blob) {
          let fileUrl = URL.createObjectURL(this.content);
          if (this.content.type === 'application/ics') {
            fileUrl = `data:text/calendar;charset=utf8, ${encodeURI(this.blobToString(this.content))}`;
          }
          this.nativeWindow.open(fileUrl, '_blank');
        } else if (this.token && this.token !== '') {
          this.nativeWindow.open(`${this.content}?token=${this.token}`, '_blank');
        }
      }
    }
  }

  private blobToString(b) {
    const objectUrl = URL.createObjectURL(b);
    const xRequest = new XMLHttpRequest();
    xRequest.open('GET', objectUrl, false); // although sync, you're not fetching over internet
    xRequest.send();
    URL.revokeObjectURL(objectUrl);
    return xRequest.responseText;
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/components/base-file-type/base-file-type.component.ts